const emailPattern = /^([a-zA-Z0-9_.-])+@(usecology.com)|(smartersorting.com)|(eqonline.com)+$/;

export default emailPattern;
